/**
 * Route for `igaming-brands`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingBrandsPage } from "../features/igaming-brands/IgamingBrandsPage";

export const igamingBrandsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-brands",
	component: IgamingBrandsPage,
});

export default igamingBrandsRoute;
